import AdminAccessRightDialog from './admin-access-right-dialog.container';

export default AdminAccessRightDialog;
